
	import { Observer } from 'mobx-vue';
	import { Component, Vue } from 'vue-property-decorator';

	@Observer
	@Component({})
	export default class ErrorHandler extends Vue {
		private async tryAgain() {
			this.$state.utils.error = false;
			this.$state.utils.errorInfo.description = '';
			this.$state.utils.errorInfo.details = '';
			await this.$state.engine.auth.logout();
		}
		private get isProduction() {
			return process.env.NODE_ENV !== 'production';
		}
	}
